import { render, staticRenderFns } from "./CreateCollectionEvent.vue?vue&type=template&id=cf9a7e46"
import script from "./CreateCollectionEvent.vue?vue&type=script&lang=js"
export * from "./CreateCollectionEvent.vue?vue&type=script&lang=js"
import style0 from "./CreateCollectionEvent.vue?vue&type=style&index=0&id=cf9a7e46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports